import { getTodos } from "../api/epicApi";
import * as types from "../constants/actionTypes";
import { call, put, select, takeLatest } from "redux-saga/effects";
import * as d from "../reducers/domainReducer";
import { logAPI } from "../api/andyliticsApi";

export default function* todosSaga() {
    //yield takeLatest([types.LOAD_DASHBOARD_START], handleAction);
    //yield takeLatest([types.USER_AUTHENTICATE_SUCCESS], handleAction);
    yield takeLatest([types.INITIATE_TODOS], handleAction);
    yield takeLatest([types.PROXY_LIST_LOADED], handleAction);
    yield takeLatest([types.PROXY_LIST_FAILURE], handleAction);
    yield takeLatest([types.SWITCH_USER_SAGA], handleAction);
}

export function* handleAction(payload) {

    const start = new Date();
    const userDetails = yield select((state) => state.sso.userDetails);
    const currentUser = payload && payload.user ? payload.user : d.hydrateProxyUser(yield select(state => state.domain.cu));
    try {
        if (userDetails && userDetails.userName) {
            if (currentUser && currentUser.externalId) {//Bug-34585
                const response = yield call(getTodos, userDetails.userName, currentUser.externalId, userDetails.access_token);
                logAPI("MBHWeb.Saga.Todos.Get", start, null);
                yield put({ type: types.TODOS_SUCCESS, todos: response, isWaiting: false });
            }
            else {
                const error = 'Patient ID is not available.';
                yield put({ type: types.TODOS_FAILURE, error: error });
                logAPI("MBHWeb.Saga.Todos.Get.Failure.PatientIdNotAvailable", start, null, error);
            }
        }
    }
    catch (response) {
        console.error(response);
        // Microsoft Edge throws TypeMismatchError when fetch returns 401
        if (response !== null) {
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.Todos.Get.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.TODOS_FAILURE, error: response });
                logAPI("MBHWeb.Saga.Todos.Get.Failure", start, null, response);
            }
        }
        else {
            logAPI("MBHWeb.Saga.Todos.Get.Failure", start, null, response);
        }
    }
}